import { Injectable } from '@angular/core';
import { CourseProgram, LearningAreasFolders, LearningAreasString } from 'src/app/model/course-program';


@Injectable({
  providedIn: 'root',
})
export class UniversityService {
  public path: string = '/assets/images/corsi';

  constructor() {
  }

  public getProductDescription(code: string){
    switch (code) {
      case 'MAGOCLD': return 'MagoCloud';
      case 'MAGO4': return 'Mago4';
      case 'MAGOWEB': return 'MagoWeb';
      case 'RETAIL': return 'Store Management';
      case 'TBS': return 'Task Builder Studio Personal & Professional Edition';
      case 'IMS': return 'Integration Management System';
      case 'IMAGO': return 'I.Mago';
      default: return code
    }
  }

  public fileExists(path: string, course: CourseProgram): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let ele = document.createElement("img");
      ele.id = course.CourseName;
      ele.onerror = () => resolve(false);
      ele.onload = () => resolve(true);
      ele.src = path;
    });
  }

  public async getImage(course: CourseProgram){
    let imageName: string = ""
    Object.keys(LearningAreasFolders).forEach(la => {
      if(LearningAreasFolders[la] == course.LearningArea)
        imageName = la
    })
    let path = `${this.path}/${course.ProductCode}/${course.LearningArea.toString()}/${imageName}.jpg`
    let fileExist = this.fileExists(path, course)
    if(await fileExist == true)
      return path
    else
      return `${this.path}/MAGO-generic/${course.LearningArea.toString()}/${imageName}.jpg`
  }
}
